module.exports = __webpack_public_path__ + "static/half_elf-ed63011d635b21e8dd93a763f3a077eb.webp";